import { type FC } from 'react'
import { Alert } from '@retailer-platform/shared-components/src/tds'
import { spacing } from '@retailer-platform/shared-components'
import { type NoticeBannerVariantEnum } from '../../__codegen__/api'
import { useActiveNoticeBanners } from './NoticeBannerHost.hooks'
import { dismiss, isDismissed } from './noticeBannerDismissal'

// Use string literal keys (the enum's runtime values) to avoid accessing the
// enum at module initialization time, which crashes if api.ts is partially
// evaluated due to a circular dependency in wider app import chains.
const variantMap: Record<NoticeBannerVariantEnum, 'info' | 'warning' | 'error' | 'success'> = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success',
}

export const NoticeBannerHost: FC = () => {
  const banners = useActiveNoticeBanners()
  const visible = banners.filter(b => !isDismissed(b.id, b.updatedAt))

  if (visible.length === 0) return null

  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: spacing.X8,
      }}
    >
      {visible.map(b => (
        <Alert
          key={b.id}
          layout="horizontal"
          variant={variantMap[b.variant]}
          isDismissible={b.dismissible}
          onDismiss={b.dismissible ? () => dismiss(b.id, b.updatedAt) : undefined}
        >
          {b.body}
        </Alert>
      ))}
    </div>
  )
}
